[
  {
    "code": "ME-01",
    "name": "Andrijevica"
  },
  {
    "code": "ME-02",
    "name": "Bar"
  },
  {
    "code": "ME-03",
    "name": "Berane"
  },
  {
    "code": "ME-04",
    "name": "Bijelo Polje"
  },
  {
    "code": "ME-05",
    "name": "Budva"
  },
  {
    "code": "ME-06",
    "name": "Cetinje"
  },
  {
    "code": "ME-07",
    "name": "Danilovgrad"
  },
  {
    "code": "ME-08",
    "name": "Herceg-Novi"
  },
  {
    "code": "ME-09",
    "name": "Kolašin"
  },
  {
    "code": "ME-10",
    "name": "Kotor"
  },
  {
    "code": "ME-11",
    "name": "Mojkovac"
  },
  {
    "code": "ME-12",
    "name": "Nikšic´"
  },
  {
    "code": "ME-13",
    "name": "Plav"
  },
  {
    "code": "ME-14",
    "name": "Pljevlja"
  },
  {
    "code": "ME-15",
    "name": "Plužine"
  },
  {
    "code": "ME-16",
    "name": "Podgorica"
  },
  {
    "code": "ME-17",
    "name": "Rožaje"
  },
  {
    "code": "ME-19",
    "name": "Tivat"
  },
  {
    "code": "ME-20",
    "name": "Ulcinj"
  },
  {
    "code": "ME-18",
    "name": "Šavnik"
  },
  {
    "code": "ME-21",
    "name": "Žabljak"
  }
]